module.exports = __webpack_public_path__ + "static/melbourne-3c728e5e564446cb4d7c3de31405d3b8.png";